import React, { ReactNode } from 'react';
import Style from './HeaderSection.style';
import { FunctionComponent } from 'react';
import { BgStars } from 'View/Component';
import { Image } from 'View/Common';
import { CoopLogoBackground } from 'img/b2b/CoopLandingPage';
import LunaSleeping from 'img/luna-sleeping.svg';

export type THeaderSectionProps = {
  children?: ReactNode;
  brandLogo?: ReactNode;
};

export const HeaderSection: FunctionComponent<THeaderSectionProps> = ({ children, brandLogo }) => {
  return (
    <Style className="header-section">
      <BgStars>
        <Image className="header-image" src={LunaSleeping} alt="Schlafen" />
        {children}
      </BgStars>
      {brandLogo && (
        <div className="brand-logo-wrapper">
          <Image className="logo-background" src={CoopLogoBackground} alt="Schlafen" />
          {brandLogo}
        </div>
      )}
    </Style>
  );
};
